export default function tree(categories, parent = undefined) {
    return categories
        .filter((category) => category.parentCategory?.id === parent?.id)
        .map(
            (category) => {
                return {
                    category,
                    children: tree(categories, category),
                };
            },
        );
}
